import { render } from "./HeaderOne.vue?vue&type=template&id=2ad34806"
import script from "./HeaderOne.vue?vue&type=script&lang=js"
export * from "./HeaderOne.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__